import React from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import SuccessIcon from "../Assets/Icons/matchedIcon.svg";
import AiSuccessProjectCard from "../Components/AiSuccessProjectCard";
import SuccessTeamCard from "../Components/SuccessTeamCard";
import TeamImg from "../Assets/TeamImg.png";
import EyeIcon from "../Assets/Icons/eyeIcon.svg";

import ProjectImg from "../Assets/ProjectImg.png";
export default function AiProjectSuccessMatch() {
  return (
    <DashboardLayout>
      <section className="w-full bg-[#F3F4F6] px-6 pt-5">
        <div
          style={{
            boxShadow:
              " 0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)",
          }}
          className="w-full py-8 px-5 bg-white "
        >
          <div>
            <img src={SuccessIcon} />
            <div className="flex flex-col gap-1 mt-6">
              <p className="text-[1.1rem] text-[#111928] font-[700]">
                Success!
              </p>
              <p className="text-[1rem] text-[#6B7280]">
                Here are the 3 recommended teams that can work on this project
                based on skills match, experience, and available hours.
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-2 mt-6">
            <p className="text-[1rem] text-[#6B7280]">AI Project</p>
            <AiSuccessProjectCard
              projectimg={ProjectImg}
              projecttitle="Project Title"
              location="Riyadh, KSA"
              desc="Lorem ipsum dolor sit amet consectetur. Imperdiet a sed arcu nunc dolor sed nisi id aenean. "
              teamimg={ProjectImg}
              teamname="Team Name"
              duetime="21h 31m"
            />
          </div>
          <div className="mt-8">
            <p className="text-[1rem] text-[#6B7280]">
              Here are the 3 recommended teams
            </p>
            <div className="flex items-center justify-between mt-2">
              <SuccessTeamCard
                teamimg={TeamImg}
                teamname="Team Name"
                text="About this AI Team Extracted from their Team Profile Page."
                projectname="none"
              />
              <SuccessTeamCard
                teamimg={TeamImg}
                teamname="Team Name"
                text="About this AI Team Extracted from their Team Profile Page."
                projectname="none"
              />
              <SuccessTeamCard
                teamimg={TeamImg}
                teamname="Team Name"
                text="About this AI Team Extracted from their Team Profile Page."
                projectname="none"
              />
            </div>
          </div>
          <div className="mt-8">
            <button className="w-full h-[2.5rem] border-[1px] border-[#942A27] rounded-[8px] text-[0.95rem] text-[#942A27] flex items-center justify-center gap-3 font-[500]">
              <img src={EyeIcon} />
              View All AI Projects
            </button>
          </div>
        </div>
      </section>
    </DashboardLayout>
  );
}
